<template>
  <div class="card">
    <div class="card--header">{{ $t("workspace.members") }}</div>
    <div class="wrapper" v-if="pagination">
      <div class="card--item" v-for="item in pagination.docs" :key="item._id">
        <div class="card--item--photo rounded-circle">
          <img v-if="item.avatar" :src="item.avatar" alt="" />
          <img v-else src="@/assets/images/user.png" alt="" />
        </div>
        <div>
          <div class="card--item--name">{{ item.name }}</div>
          <div class="card--item--profession">{{ item.email }}</div>
        </div>

        <!--

      <div class="dropdown-icon">
        <b-dropdown id="workspace-member-dropdown" variant="link" no-caret>
          <template #button-content>
            <div class="mdi mdi-dots-horizontal icon"></div>
          </template>
          <b-dropdown-item>Seçenek 1</b-dropdown-item>
          <b-dropdown-item>Seçenek 2</b-dropdown-item>
        </b-dropdown>
      </div>
    -->
      </div>
    </div>

    <empty v-if="!pagination || pagination.docs.length == 0">
      <h5 class="text-center" id="myText">
        {{ $t("common.not-found") }}
      </h5>
    </empty>
    <br v-if="!pagination || pagination.docs.length == 0" />

    <template v-if="pagination">
      <div class="d-flex justify-content-center my-3">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
  },
  computed: {
    pagination() {
      return this.$store.getters["workspace/paginationMember"];
    },

    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
  },
  methods: {
    paginate() {
      if (!this.currentWorkspace) {
        return;
      }
      this.$store.dispatch(`workspace/paginateMember`, { pagination: this.request, id: this.currentWorkspace?._id });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 20px;
  color: rgb(193 197 201);
  width: 1.8rem;
  height: 2rem;
  border-radius: 50%;
}
.icon:hover {
  background-color: #e7e7e8;
}
.dropdown-icon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 2rem;
  height: 2rem;

  margin-left: auto;
  border-radius: 50%;
  cursor: pointer;
}
</style>
